import * as url from "./config";

// constants for api URL
// var BASEURL = url.LOCAL_API_URL; //Local server
// var BASEURL = url.PRODUCTION_API_URL;	//Staging server
// var BASEURL = url.CLIENT_LIVE_API_URL; //Client live Production server
// var BASEURL = url.CLIENT_PROD_API_URL;
var BASEURL = url.getURLForServer(process.env.REACT_APP_NODE_ENV).CLIENT_TEST_LIVE_API_URL; //Client test server

//Admin
export const ADMIN_LOGIN = BASEURL + "api/admin/adminLogin";
export const ADD_USER = BASEURL + "api/admin/addAdminUser";
export const GET_USER_LIST = BASEURL + "api/admin/getAdminUserList";
export const DELETE_USER = BASEURL + "api/admin/deleteAdminUser";
export const GET_USER_BY_ID = BASEURL + "api/admin/getUserById";
export const UPDATE_USER = BASEURL + "api/admin/updateAdminUser";

export const CREATE_COMMISSION = BASEURL + "api/CreateCommission";
export const TRANSACTION_FEE = BASEURL + "api/createTransactionFee";
export const SUBMIT_INVOICE_DAY = BASEURL + "api/invoice/submitInvoiceDay";

//Sign In
export const USER_AUTH = BASEURL + "api/loggedin";
export const SIGN_IN_USER = BASEURL + "api/userLogin";
export const SIGN_UP_USER = BASEURL + "api/userRegister";
// export const SIGN_UP_USER_NEW = BASEURL + "api/userNew";
export const FORGOT_PASSWORD = BASEURL + "api/userForgotPassword";
export const RESET_PASSWORD = BASEURL + "api/resetPassword";
export const ACTIVATE_ACCOUNT = BASEURL + "api/activateAccount";
export const UNSUBSCRIBE_EMAILS = BASEURL + "api/unsubscribeEmails";
export const UNSUBSCRIBE_EMAILS_VIA_PROFILE = BASEURL +"api/unsubscribeEmailsViaProfile"
export const OTP_VERIFICATION = BASEURL +'api/otpVerification';
export const IS_TOKEN_VALID = BASEURL + "api/checkToken";
export const CHANGE_EMAIL = BASEURL + "api/changeEmail";
export const UNLOCK_ACCOUNT = BASEURL + "api/unlockYourAccount";
export const GET_SPECIALIST_FOR_IMAGES = BASEURL + "api/admin/getSpecialistForProfileImage";
export const GET_APPROVED_SPECIALIST_FOR_IMAGES =  BASEURL + "api/admin/getSpecialistWithApprovedProfileImage"
export const GET_APPROVED_BLOGS_FOR_IMAGES = BASEURL + 'api/admin/getBlogsWithApprovedImages'
export const GET_BLOGS_FOR_IMAGES = BASEURL + "api/admin/getBlogImagesForAdmin"
export const UPDATE_PROFILE_IMAGE_VERIFIED = BASEURL + "api/admin/updateIsProfileImageVerified";
export const UPDATE_BLOGS_IMAGE_VERIFIED = BASEURL + "api/admin/updateBlogImageVerified";


//User Management
export const UPDATE_USER_PROFILE = BASEURL + "api/updateProfile";
export const GET_USER_DETAILS = BASEURL + "api/getUserDetails";
export const UPLOAD_PATIENT_IMAGE = BASEURL + "api/patients/uploadPatientImage";
export const UPLOAD_ADMIN_IMAGE = BASEURL + "api/adminUpdateImage";

export const CHANGE_PASSWORD_FROM_PROFILE = BASEURL + "api/changePassword";


//Specialist Component
export const GET_SPECIALISTS_ALL_AVAILABILITY =
	BASEURL + "api/specialist/getSpecialistAllAvailabilityAddresses";
export const GET_SPECIALISTS = BASEURL + "api/getSpecialists";
export const GET_SPECIALISTS_LIST =
	BASEURL + "api/specialist/getSpecialistList";

export const GET_SPECIALISTS_ASSISTANT_LIST =
	BASEURL + "api/getSpecialistsAssistant";
export const GET_SPECIALIST_DETAIL_CALENDAR =
	BASEURL + "api/specialist/getSpecialistDetailCalendar";
export const GET_SPECIALIST_DETAIL =
	BASEURL + "api/specialist/getSpecialistDetails";
export const UPLOAD_SPECIALIST_IMAGE =
	BASEURL + "api/specialist/uploadSpecialistImage";
export const DELETE_PROFILE_IMAGE =
	BASEURL + "api/users/deleteProfileImage";
export const GET_EXPERIENCE_LIST =
	BASEURL + "api/specialist/getExperienceCount";
export const SAVE_SPECIALIST_PROFILE =
	BASEURL + "api/specialist/updateSpecialistProfile";
export const GET_SPECIALIST_PROFILE =
	BASEURL + "api/specialist/getSpecialistDataOnProfile";
export const SAVE_AVAILABILITY = BASEURL + "api/specialist/saveAvailability";
export const SAVE_TEMP_AVAILABILITY = BASEURL + "api/specialist/saveTempAvailability";
export const CHECK_ZIPCODE = BASEURL + "api/specialist/checkZipcode";
export const DELETE_AVAILABILITY =
	BASEURL + "api/specialist/deleteAvailability";
export const GET_AVAILABILITY = 
    BASEURL + "api/specialist/getAvailabilitySlot";

export const UPDATE_CLINIC_BANNER_IMAGE = 
    BASEURL + "api/specialist/updateClinicBannerImage";
export const DELETE_CLINIC_BANNER_IMAGE = 
	BASEURL + "api/specialist/deleteClinicBannerImage"




	


export const GET_SPECIALIST_PATIENTS =
	BASEURL + "api/specialist/getSpecialistPatients";
export const GET_OTHER_CONSULTATION_ADDRESS =
	BASEURL + "api/specialist/getSpecialistAllAvailabilityAddresses";
export const GET_MY_FEEDBACK = BASEURL + "api/rating/getSpecialistAllRating";
export const GET_MY_FEEDBACK_DETAIL =
	BASEURL + "api/rating/getSpecialistRating";
export const RESPOND_TO_PATIENT =
	BASEURL + "api/rating/respondToPatientFeedback";
export const REMIND_FEEDBACK_LATER = BASEURL + "api/rating/rateRemindLatter";
export const GET_REMINDER_FEEDBACK = BASEURL + "api/rating/getReminderList";
export const GET_NEXT_REMINDER = BASEURL + "api/rating/closeReminderBringNext";
export const UPDATE_IS_DOWNLOAD = BASEURL + "api/appointment/updateIsDownloaded"
export const VERIFY_SPECIALIST_STRIPE =
BASEURL + "api/specialist/verifySpecialistStripe";
export const GET_SPECIALIST_STRIPE_DETAILS =
BASEURL + "api/specialist/getSpecialistStripeDetails";
export const UPDATE_DOCUMENT_STATUS =
BASEURL + "api/specialist/updateDocumentStatus";
export const CHANGE_SPECIALIST_EMAIL =
BASEURL + "api/specialist/changeSpecialistEmail";


export const CHANGE_SPECIALIST_PHONE_NO =
BASEURL + "api/user/changeUserPhoneNumber";


export const CHANGE_PHONE_DISPLAY_ON_PROFILE = 
BASEURL + "api/specialist/changeSpecialistPhoneOption";



//Specialization
export const GET_SPECIALIZATION_LIST =
BASEURL + "api/specialization/getSpecializationList";
//GET_SPECIALIZATION_LIST /api/specialization/getSpecializationList
export const GET_SUBSPECIALIZATION_LIST =
BASEURL + "api/specialization/getSubSpecializationList";
export const GET_CONDITIONAL_PROCEDURE_MAPPING_LIST =
BASEURL + "api/specialization/getConditionalProcedureMapping";
export const ADD_PRESCRIPTION_DATA =
BASEURL + "api/specialization/addPrescriptionData";
export const ADD_PRESCRIPTION_IMAGE =
BASEURL + "api/specialization/addPrescriptionImages";
export const GET_APPOINTMENTS_FOR_MONTH =
BASEURL + "api/specialization/getAppointmentsForMonth";
export const GET_APPOINTMENTS_FOR_DAY =
BASEURL + "api/specialization/getAppointmentsForDay";
export const GET_SPECIALIST_DETAIL_FOR_BLOCKING =
BASEURL + "api/specialization/getSpecialistDetailForBlocking";
export const GET_SPECIALIST_BLOCKINGS =
BASEURL + "api/specialization/getSpecialistBlockings";
export const CREATE_TOKEN =
BASEURL + "api/createToken";

//Appointment Component
export const GET_APPOINTMENTS = BASEURL + "api/getAppointmentList";
export const GET_SPECIALISTAVABILITY =
BASEURL + "api/appointment/getSpecialistAvailability";
export const GET_SPECIALIST_BLOCK_DATES =
BASEURL + "api/appointment/getBlockAppointmentDate";
export const BOOK_APPOINTMENT = BASEURL + "api/appointment/bookAppointment";
export const ADD_APPOINTMENT_DETAILS =
BASEURL + "api/appointment/addAppointmentDetails";
export const CANCEL_APPOINTMENT = BASEURL + "api/appointment/cancelAppointment";
export const CREATE_SESSIONID_TOKEN =
BASEURL + "api/video/createTokenAndSessionId";
export const DISCONNECT_SESSIONID_TOKEN =
BASEURL + "api/video/disconnectSessionIdToken";
export const GET_PATIENT_ALL_HISTORY =
BASEURL + "api/appointment/getSpecialistAppointmentDetail";
export const GET_PATIENT_ALL_CONSULT_HISTORY =
BASEURL + "api/patients/getPatientAllHistory";

export const GET_RATING_QUESTIONS = BASEURL + "api/rating/getRatingQuestions";
export const ADD_RATING = BASEURL + "api/rating/addSpecialistRating";
export const DONT_REMIND_FEEDBACK_AGAIN =
BASEURL + "api/rating/dontRemindFeedbackAgain";

export const GET_APPOINTMENT_DETAIL_RATE =
BASEURL + "api/appointment/getAppointmentWithRatingDetails";

// upload document
export const UPLOAD_APPOINTMENT_DOCUMENT =
BASEURL + "api/appointment/uploadAppointmentDocument";
export const GET_DOCUMENT_TYPE = BASEURL + "api/document/getDocumentType";
export const GET_ALL_DOCUMENT_TYPES =
BASEURL + "api/document/getAllDocumentTypes";


export const GET_SPECIALIST_DOCUMENT_AND_STATUS = 
	BASEURL + "api/specialist/getSpecialistDocumentAndStatus";
export const UPLOAD_SPECIALIST_DOCUMENT =
	BASEURL + "api/specialist/uploadSpecialistDocument";

// export const UPLOAD_SPECIALIST_DOCUMENT =
// 	BASEURL + "api/specialist/uploadSpecialistDocument";


export const DELETE_APPOINTMENT = BASEURL + "api/appointment/deleteAppointment";
export const DELETE_DOCUMENT = BASEURL + "api/appointment/deleteDocument";
export const GET_APPOINTMENT_DOCUMENT =
BASEURL + "api/appointment/getAppointmentDocuments";
export const GET_APPOINTMENT_DETAILS =
BASEURL + "api/appointment/getAppointmentDetails";

export const GET_SPECIALIST_DOCUMENT =
BASEURL + "api/specialist/getSpecialistDocument";
export const DELETE_SPECIALIST_DOCUMENT =
BASEURL + "api/specialist/deleteSpecialistDocument";
export const GET_SPECIALIST_DOCUMENT_BY_ID =
BASEURL + "api/specialist/getSpecialistDocumentById";
export const SUBMIT_DOCUMENT_FOR_VERIFICATION =
BASEURL + "api/document/submitForVerification";
export const SET_DOCUMENT_EXPIRY_DATE =
BASEURL + "api/document/setDocumentExpiryDate";




export const GET_SPECIALIST_DOCUMENT_TYPE = 
BASEURL + "api/specialist/getSpecialistDocument";





//Blood group

export const GET_BLOOD_GROUP_LIST =
BASEURL + "api/bloodGroup/getBloodGroupList";
//Specilaits Health Tips
export const ADD_SPECIALIST_BLOG = BASEURL + "api/specialist/addSpecialistBlog";
export const GET_SPECIALIST_BLOG_LIST =
BASEURL + "api/specialist/getSpecialistBlogList";
export const GET_SPECIALIST_BLOG_BY_ID =
BASEURL + "api/specialist/getSpecialistBlogById";
export const DELETE_SPECIALIST_BLOG =
BASEURL + "api/specialist/deleteSpecialistBlog";
export const GET_ALL_BLOG_LIST = BASEURL + "api/getAllBlogList";
export const GET_ALL_ADMIN_BLOG_LIST = BASEURL + "api/admin/getAllBlogList";
export const LIKE_AND_UNLIKE_BLOG = BASEURL + "api/likeandUnLikeBlog";
export const FAVOUITE_AND_UNFAVOUITE_BLOG =
BASEURL + "api/favouriteAndUnFavouriteBlog";
export const GET_BLOG_DETAILS_BY_ID = BASEURL + "api/getBlogDetailsById";
export const GET_MARKETING_ALL_BLOG_LIST =
BASEURL + "api/getMarketingAllBlogList";
export const GET_MARKETING_ALL_BLOG_LIST_ADMIN =
BASEURL + "api/getMarketingAllBlogListAdmin";
export const GET_MARKETING_BLOG_DETAILS_BY_ID =
BASEURL + "api/getMarketingBlogDetailsById";
export const GET_ADMIN_BLOG_DETAILS_BY_ID =
BASEURL + "api/getAdminBlogDetailsById";

//Country
export const GET_COUNTRIES_LIST = BASEURL + "api/Country/getCountryList";
export const GET_STATES_LIST = BASEURL + "api/Country/getStateList";
export const GET_PATIENT_HISTORY = BASEURL + "api/getPatientHistory";

export const GET_QUESTION_RATING =
BASEURL + "api/rating/getAvgRatingByQuestions";
export const ADD_CURRENCY_FILTER = BASEURL + "api/admin/addCurrencyFilter"
export const LIST_CURRENCY_FILTER = BASEURL + 'api/admin/listCurrencyFilter'
export const GET_APPOINTMENTS_COUNT =
BASEURL + "api/dashboard/getAppointmentsCount";
export const UPDATE_APPOINTMENT_SHOW =
BASEURL + "api/appointment/updateAppointmentShowDetails";
export const SAVE_CONSULTATION =
BASEURL + "api/appointment/saveConsultationForm";
export const GET_CONSULTATION_DETAIL =
BASEURL + "api/appointment/getConsultationDetail";
export const NO_SHOW_APPOINTMENT =
BASEURL + "api/appointment/noShowAppointment";
export const LOGOUT = BASEURL + "api/logout";
export const VERIFY_PASSWORD = BASEURL + "api/verifyPassword";
export const GET_APPOINTMENTS_FOR_HEALTH_RECORD =
BASEURL + "api/appointment/getAppointmentsForHealthRecord";
export const STRIPE_PAYMENT = BASEURL + "api/payment/stripepayment";

//vetting users

export const GET_ALL_SPECIALISTS = BASEURL + "api/admin/getAllSpecialists";
export const GET_ALL_PATIENTS = BASEURL + "api/admin/getAllPatients";
export const GET_USER_NOTIFICATIONS = BASEURL + "api/notifications/getUserNotifications";
export const CLEAR_ALL_NOTIFICATIONS = BASEURL + "api/notifications/clearAllNotifications"
export const CHANGE_USER_STATUS = BASEURL + "api/disableUser";
export const DELETE_USER_ACCOUNT = BASEURL + "api/deletePatientAccount";
export const DELETE_DOCTOR_ACCOUNT = BASEURL + "api/deleteDoctorAccount";
// Statistics
export const PATIENT_VS_APPOINTMENTS =
BASEURL + "api/statistics/getNoOfPatientNAppointmentStats";
export const TOTAL_TURNOVER_VS_REVENU =
BASEURL + "api/statistics/getRevenueOfCountryMedfix";
export const GET_REVENUE_BY_STATUS_COUNTRY =
BASEURL + "api/statistics/getRevenueByStatusandCountry";
export const TOTAL_TURNOVER_F2F_ON_VS_REVENU =
BASEURL + "api/statistics/getRevenueOfCountry";
export const RATE_VS_PATIENT =
BASEURL + "api/statistics/getNoOfSpecialistRateStats";
export const APPOINTMENT_REVENUE =
BASEURL + "api/statistics/getAppointmentRevenueStats";
export const MEDFIX_REVENUE = BASEURL + "api/statistics/getMedfixRevenueStats";

export const UPDATE_SPECIALIST_VERIFICATION =
BASEURL + "api/specialist/updateSpecialistVerification";
export const MISSED_DOCUMENTS = BASEURL + "api/specialist/missedDocuments";
export const ADD_EMAIL_TEMPLATE = BASEURL + "api/admin/addeditemailTemplates";
export const GET_EMAIL_TEMPLATES = BASEURL + "api/admin/getemailTemplates";
export const GET_EMAIL_TEMPLATE_BY_ID =
BASEURL + "api/admin/getemailTemplateById";
export const GET_PAGES_LIST = BASEURL + "api/admin/getPagesList";
export const GET_PAGE_BY_ID = BASEURL + "api/admin/getPageById";
export const ADD_EDIT_PAGE = BASEURL + "api/admin/addEditPage";
export const GET_LOGS_LIST = BASEURL + "api/getLogList";
export const GET_FEEDBACKS_LIST = BASEURL + "api/admin/getAllFeedbacks";
export const UPDATE_FEEDBACK_STATUS =
BASEURL + "api/admin/updateFeedbackStatus";

//Marketing

export const GET_MARKETING_SPECIALIZATION =
BASEURL + "api/specialization/getMarketingSpecializationList";
export const GET_MARKETING_SPECIALISTS_LIST =
BASEURL + "api/marketSpecialist/getMarketingSpecialistList";
export const GET_MARKET_OTHER_CONSULTATION_ADDRESS =
BASEURL + "api/marketSpecialist/getMarketSpecialistAllAvailAddress";
export const GET_CMS_PAGE_CONTENT =
BASEURL + "api/cmsContent/getCmsPageContent";

export const SAVE_CONTACT_US_FORM = BASEURL + "api/contactUs/saveContactUsForm";


// upgrade to react 16.8
export const EDIT_FEEDBACK_PATIENT = BASEURL + "api/admin/editFeedbackPatient";
export const EDIT_FEEDBACK_SPECIALIST = BASEURL + "api/admin/editFeedbackSpecialist";

// gapi_calendar 
export const GAPI_AUTH = BASEURL + "api/gapi/auth";
export const PUT_GAPI_TOKEN = BASEURL + "api/gapi/token";
export const GET_USERS_SYNC_STATUS = BASEURL + "api/gapi/checkUserSyncStatus";
// export const REVOKE_GAPI_TOKEN = BASEURL + "api/gapi/token";

//OUTLOOK Calendar
export const OUTLOOK_AUTH = BASEURL + "api/outlook/auth";
export const PUT_OUTLOOK_TOKEN = BASEURL + "api/outlook/token";
export const GET_USERS_OUTLOOK_SYNC_STATUS = BASEURL + "api/outlook/checkUserSyncStatus";


//icalendar FILE
export const GET_iCAL_FILE = BASEURL + "api/ics/icsFileGenerator";
export const STORE_USER_ICLOUD_EMAIL = BASEURL + "api/icloud/addemailtouser";
export const GET_USERS_ICLOUD_SYNC_STATUS = BASEURL + "api/icloud/checkUserSyncStatus";
export const REMOVE_USER_ICLOUD_EMAIL = BASEURL + "api/icloud/removeiCalFromUser";

// block availability
export const WEEKLY_BLOCK_AVAILABILITY = BASEURL + "api/appointment/saveWeeklyblockavailability";
export const DAILY_BLOCK_AVAILABILITY = BASEURL + "api/appointment/saveDailyBlockAvailability";
export const MONTHLY_BLOCK_AVAILABILITY = BASEURL + "api/appointment/saveMonthlyBlockAvailability";
export const YEARLY_BLOCK_AVAILABILITY = BASEURL + "api/appointment/saveYearlyBlockAvailability";


//update bl;ock availability
export const UPDATE_WEEKLY_BLOCK_AVAILABILITY = BASEURL + "api/appointment/updateWeeklyBlockedAvailability";


export const DELETE_EVENT = BASEURL + "api/deleteRecurringEvents";

// export const SAVE_CONTACT_US_FORM = BASEURL + "api/contactUs/saveContactUsForm";
export const RESEND_OTP = BASEURL + "api/resendOTP";
export const WINDOW_CLOSE = BASEURL + "api/windowClose";

export const GET_PAYMENT_CONFIG = BASEURL +"api/getPaymentConfig";

// view receipt 
export const GET_APPOINTMENT_RECEIPT =
BASEURL + "api/appointment/viewReceipt";

export const ADD_DISPUTE_CONTENT =
BASEURL + "api/admin/addDisputeCategory";

export const ADD_SUB_DISPUTE_CONTENT =
BASEURL + "api/admin/addSubDisputeCategory";
export const EDIT_SUB_DISPUTE_CONTENT =
BASEURL + "api/admin/editSubDisputeCategory";
export const DELETE_SUB_DISPUTE_CONTENT =
BASEURL + "api/admin/deleteSubDispute";

// dispute module
export const GET_DISP_SUB_LIST =
BASEURL + "api/admin/getDisputeSubDisputeList";
export const GET_SUBDISPUTE_DETAIL =
BASEURL + "api/admin/getSubdisputeDetail";
export const GET_SUBDISPUTE_LIST =
BASEURL + "api/admin/getSubdisputeList";
export const SUBMIT_DISPUTE_TO_ZENDESK =
BASEURL + "api/admin/submitDisputeToZendesk";
export const VIEW_RECIPT =
BASEURL + "api/dispute/viewReceipt";
export const SEARCH_DISPUTE =
BASEURL + "api/dispute/searchDispute";

// get all disputed appointments
export const GET_DISPUTED_APPOINTMENTS =
BASEURL + "api/dispute/getAllDisputedAppointments";
export const GET_DISP_SUB_LIST_ADMIN =
BASEURL + "api/admin/getDisputeSubDisputeListAdmin";
export const GET_DISPUTED_APPOINTMENT_DETAILS =
BASEURL + "api/admin/getDisputedAppointmentDetails";
export const MARK_USER_DISPUTE_AS_RESOLVED =
BASEURL + "api/admin/markUserDisputeAsResolved";


export const ADD_LANGUAGE_CATEGORY =
BASEURL + "api/admin/addLanguageCategory";

export const ADD_LANGUAGE_TO_SPECIALIST = BASEURL + "api/specialist/addLanguageToSpecialist";

export const SEND_CASH_APPOINTMENT_EMAIL =
BASEURL + "api/appointment/sendCashAppointmentEmail";

export const GET_SPECIALIST_DETAIL_FOR_APPOINTMENT =
BASEURL + "api/appointment/getSpecialistInfoForAppointment";